import React, { useEffect, useRef, useState } from 'react';
import RouterConfig from './../router/RouterConfig';
import { ThemeProvider  } from 'styled-components';
import { GlobalStyles } from '../styles/GlobalStyles';
import { color } from './../utilities/constants';
import logoImgIS from './../assets/images/islab_logo.png';
import { IconClose, IconMenu } from '../utilities/SVG';
import { NavLink } from 'react-router-dom';
import {
    LeftContent,
    BgMenu,
    MenuOverlay,
    AllRouter,
} from './App.style';
import { useGetData } from '../utilities/api';

import { useTranslation } from "react-i18next";


function App() {
    const [theme, setTheme] = useState(color.themeLight);
    const { t } = useTranslation();

    const mainMenu = useRef(null);
    const menuIconRef = useRef(null);
    const bgMenuRef = useRef(null);

    useEffect(() => {
        calcPosBgMenu();
        window.addEventListener('resize', calcPosBgMenu);

        return () => {
            window.removeEventListener('resize', calcPosBgMenu);
        }
    }, [])

    const calcPosBgMenu = () => {
        let bounding = menuIconRef.current.getBoundingClientRect();
        bgMenuRef.current.style.top = bounding.top + 'px';
        bgMenuRef.current.style.left = bounding.left + 'px';
        bgMenuRef.current.style.width = bounding.width + 'px';
        bgMenuRef.current.style.height = bounding.height + 'px';
    }

    const closeMenu = () => {
        mainMenu.current.classList.remove('active');
        bgMenuRef.current.classList.remove('active');
        setTimeout(() => {
            bgMenuRef.current.style.zIndex = '-99';
        }, 500)
    }

    const openMenu = () => {
        mainMenu.current.classList.add('active');
        bgMenuRef.current.classList.add('active');
        bgMenuRef.current.style.zIndex = '9';
    }

    const data = useGetData();
    //console.log(data)
    const lang =localStorage.getItem('localization');
    const dataText = lang === 'vi' ? data?.vi : data?.en;

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyles />
            <LeftContent className="left-content">

                <div className="menu-button text-center">
                    <div className="wrap-icon"
                        ref={menuIconRef}
                        onClick={openMenu}
                    >
                        <IconMenu color={theme.primary} width={25} height={25} />
                    </div>
                </div>

                <div className="main-title">
                    <div className="wrap-logo-is">
                        <img src={logoImgIS} alt="" />
                    </div>
                    <div className="title">
                        <h3 className='text-1'>{dataText?.MainTitle?.Lab}</h3>
                        <h3 className='text-2'>{dataText?.MainTitle?.Major}</h3>
                    </div>
                </div>

                <div className="wrap-qr text-center">
                    <img src={'https://www.dropbox.com/s/57qbwywyfdw65rq/islab_qr.png?dl=1'} alt="" className='img-fluid' />
                    <p className="text" style={{fontStyle: "italic", fontSize: "12px", fontWeight: "500", paddingTop: '10px'}}>{dataText?.MainTitle.Quote}</p>
                </div>

                <div className="quote">
                    <p className="text-center team" style={{fontStyle: "normal"}}>{dataText?.MainTitle.Team}</p>
                </div>

            </LeftContent>
            <BgMenu className={"bg-menu"} ref={bgMenuRef}></BgMenu>
            <MenuOverlay className="menu-overlay d-flex align-items-center" ref={mainMenu}>
                <div className="close-icon"
                    onClick={closeMenu}
                >
                    <IconClose color={theme.text} width={40} height={40} />
                </div>
                <div className="container">
                    <ul>
                        <li><NavLink to='/' onClick={closeMenu}>{dataText?.Menu.HomePage}</NavLink></li>
                        <li><NavLink to='/huong-nghien-cuu' onClick={closeMenu}>{dataText?.Menu.Research}</NavLink></li>
                        <li><NavLink to='/de-tai' onClick={closeMenu}>{dataText?.Menu.Topic}</NavLink></li>
                        <li><NavLink to='/thuc-tap' onClick={closeMenu}>{dataText?.Menu.Internship}</NavLink></li>
                        <li><NavLink to='/san-pham' onClick={closeMenu}>{dataText?.Menu.Product}</NavLink></li>
                        <li><NavLink to='/lich-su' onClick={closeMenu}>{dataText?.Menu.History}</NavLink></li>
                        <li><NavLink to='/nhom-nghien-cuu' onClick={closeMenu}>{dataText?.Menu.Group}</NavLink></li>
                        <li><NavLink to='/doi-tac' onClick={closeMenu}>{dataText?.Menu.Partners}</NavLink></li>
                    </ul>
                </div>
            </MenuOverlay>
            <AllRouter className="wrap-all-router">
                <RouterConfig theme={theme} setTheme={setTheme} data={data}/>
            </AllRouter>
            
        </ThemeProvider>
    );
}

export default App;